<template>
  <div class="terms-and-conditions rounded-lg m-8 px-8 bg-white">
    <section>
      <h2 class="py-4">
        <strong>{{ $t("Legal notice") }}</strong>
      </h2>
      <p>
        {{ $t("Medkus is a brand of {company}", { company: COMPANY.name }) }}
      </p>
      <ul>
        <li><strong>{{ $t("Company name") }}:</strong> {{ COMPANY.name }}</li>
        <li><strong>RFC:</strong> {{ COMPANY.rfc }}</li>
        <li><strong>{{ $t("Address") }}:</strong> {{ COMPANY.address }}</li>
        <li>
          <strong>{{ $t("Phone") }}:</strong>
          <a :href="`tel:${COMPANY.phone.replace(/\s/g, '')}`">{{ COMPANY.phone }}</a>
        </li>
        <li>
          <strong>WhatsApp:</strong>
          <a :href="`https://wa.me/${COMPANY.whatsapp.replace(/\D/g, '')}`">{{ COMPANY.whatsapp }}</a>
        </li>
        <li>
          <strong>{{ $t("Email") }}:</strong>
          <a :href="`mailto:${COMPANY.email}`">{{ COMPANY.email }}</a>
        </li>
        <li><strong>{{ $t("Website") }}:</strong> https://medkus.com</li>
      </ul>
      <p>
        {{ $t("Medkus is an integrative health platform and the domains medkus.com and market.medkus.com, along with their associated social media accounts, are owned and operated by {company}.", { company: COMPANY.name }) }}
      </p>
    </section>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { useSeo } from "@/composables/useSeo";
import { COMPANY } from "@/constants/company";

const { t } = useI18n();
useSeo({
  title: t("Legal notice"),
  description: t("Legal notice and company details of Medkus."),
});
</script>
